import { ToCmyk } from "@pdfking/math"
import type { ColorMap, PrintLayer } from "@pdfking/renderer-api"
import { Items, RecordCreate } from "@pdfking/tfunc"

import { PALETTE } from "#constants"
import type { Palette } from "#internal"

import { Hex } from "./Hex"

// An overlay's plate: the spot black, the viewer tints it; every other color
// white, so whatever is drawn over the spot (text, lines) knocks it out. Each
// its own color: the layout tells them apart by which one it is
const WHITE = ToCmyk(Hex("#ffffff"))
const OVERLAY: Palette = {
  lines: WHITE,
  paper: WHITE,
  primary: WHITE,
  secondary: WHITE,
  spot: ToCmyk(Hex("#000000")),
  text: WHITE,
}

// Nothing at all: the print leaves the spot's elements out
const NONE = ToCmyk(Hex("#000000", 0))

// The color map `layer`'s plate plots with, by PALETTE's names: the print in
// its own colors, without the spot's elements; an overlay only those. The
// layout is the same on both: the colors are all that change. A coating
// draws from no palette: the film's own colors (see DrawCoating)
export const InkPalette = (palette: Palette, layer: PrintLayer["enum"]): ColorMap =>
  RecordCreate(
    Items(layer === "overlay" ? OVERLAY : { ...palette, spot: NONE }).map(
      ([name, color]) => [PALETTE[name as keyof Palette], color] as const
    )
  )
